/** How a setup form saves: Plan passes its own (toast + refresh); the live sheet uses liveMutate. */
import { useMission } from '../../state/mission';
import { runMutation } from '../plan/planContext';

export type Mutate = <T>(label: string, fn: () => Promise<T>) => Promise<T | undefined>;

export const liveMutate: Mutate = (label, fn) => runMutation(label, fn, () => useMission.getState().refreshBundle());
